export const KEY_PAGE_DATA = 'KEY_PAGE_DATA';

/**
 * 获取sessionStorage中的pageData
 * @return {Object} value
 */
export const getStoragePageData = () => {
  // 缓存使用sessionStorage，会话级别
  let value = sessionStorage.getItem(KEY_PAGE_DATA);
  try {
    value = JSON.parse(value);
  } catch (e) {}
  return value;
};

/**
 * 设置sessionStorage中的pageData
 * @param {Object} value pageData
 */
export const setStoragePageData = (value) => {
  sessionStorage.setItem(KEY_PAGE_DATA, JSON.stringify(value));
};

/**
 * 设置window.PAGE_DATA
 * @param {Object} value pageData
 */
export const setWindowPageData = (value) => {
  window.data = {};
  window.SSR_DATA = {};
  window.pageData = {};
  window.data.data = window.SSR_DATA.data = window.pageData.data = value || {};
};
